import Fetch, { FetchPublic } from './index'

export const getUser = async (id) => {
  if (!id) return Promise.reject('failed to read id')

  return Fetch('/user/' + id)
}

export const getMe = async () => {
  return Fetch('/user/me')
}

export const getMeInvoices = async () => {
  return Fetch('/user/me/invoices')
}

export const getUsers = async (filters) => {
  const filter = new URLSearchParams(filters).toString()

  return Fetch(`/user?` + filter)
}

export const deleteUser = async (id) => {
  return Fetch('/user/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const updateUser = async (id, data) => {
  return Fetch('/user/' + id, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const createUser = async (data) => {
  return Fetch('/user/', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const createPublicUser = async (data) => {
  if (data.planType === undefined || data.planType === null) {
    return Promise.reject(new Error('A planType is required to create a user.'))
  }
  return FetchPublic('/user/public/' + data.planType, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
